import * as yup from 'yup';
import { getRequest, postRequest } from '../../services/httpService';

// Types
export interface PgtOrderFormType {
  embryoNo: string;
  date: string;
  time: string;
  day: string;
  stage: string;
  grade: string;
  barcode: string;
  transfer_type: string;
  plan: string;
  witness: string | number  | null; // Can be string or number, or null if not selected;
  // embryologist: string | number  | null; // Can be string or number, or null if not selecte
  embryologist: { id: string; name: string } | null;
  physician?: string | number | null; 

  selectedEmbryos: number[];
}

// Initial values
export const initialPgtOrder: PgtOrderFormType = {
  embryoNo: '',
  date: '',
  time: '',
  day: '',
  stage: '',
  grade: '',
  barcode: '',
  transfer_type: '', 
  plan: '',
  witness: '',
  embryologist: null,
  selectedEmbryos: [], // or number[],
  physician: null, // Optional field for physician
};

// Yup validation schema
export const PgtOrderValidationSchema = yup.object().shape({

  date: yup.string().required('Date is required'),
  time: yup.string().nullable(),
  barcode: yup.string().required('Barcode is required'),
  physician: yup.string().required('Physician is required'),
  embryologist: yup.object().nullable().required('Embryologist is required'),
  witness: yup.mixed().nullable(),
  transfer_type: yup.string().nullable(),

  // The rest are optional (nullable)
  embryoNo: yup.string().nullable(),
  day: yup.string().nullable(),
  stage: yup.string().nullable(),
  grade: yup.string().nullable(),
  plan: yup.string().nullable(),
  selectedEmbryos: yup.array().of(yup.number()).nullable(),
});



// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getPgtOrders(patientId: number, transfer_type: string): Promise<any> {
  const url = `embryo/?cycle__patient=${patientId}&pgt_facility__name=${transfer_type}`;
  return getRequest(url, { responseType: 'json' });
}


export const transferTypeOptions = [
  { value: 'fresh', label: 'transferTypeFresh' },
  { value: 'frozen', label: 'transferTypeFrozen' },
];



export const embryoList = [
  { id: 1, embryoNo: 'C-1', grade: '2', day: 'Day 3', stage: 'Early Blastocyst', plan: 'Transfer' },
  { id: 2, embryoNo: 'C-2', grade: '2', day: 'Day 3', stage: 'Blastocyst', plan: 'Transfer' },
  { id: 3, embryoNo: 'C-3', grade: '2', day: 'Day 3', stage: 'Full Blastocyst', plan: 'Transfer' },
  { id: 4, embryoNo: 'C-4', grade: '2', day: 'Day 3', stage: 'Blastocyst', plan: 'Transfer' },
];


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function storeBiopsy(data:any, clinicId:string): Promise<any> {
  const url = `/embryo/progenesis-order/?clinic_id=${clinicId}`;
  return postRequest(url, data, { responseType: 'json' });
}
